import { useEffect, useState } from "react";
import { devices } from "constants/breakpoints";

interface UseIsMobileProps {
    query?: string;
}

const useIsMobile = ({ query = devices.tablet }: UseIsMobileProps = {}) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);

        const updateIsMobile = () => {
            setIsMobile(media.matches);
        };

        updateIsMobile();
        media.addEventListener("change", updateIsMobile);

        return () => media.removeEventListener("change", updateIsMobile);
    }, [query]);

    return isMobile;
};

export default useIsMobile;
